import { useCallback, useState, ReactNode } from 'react';

import { ExpandButton } from 'components';

type Props = {
  children: (isExpanded: boolean) => ReactNode;
  showToggleButton: boolean;
  className?: string;
};

export const ExpandableContent: React.FC<Props> = ({
  children,
  showToggleButton,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  return (
    <div className={className}>
      {children(isExpanded)}
      {showToggleButton && (
        <div className="tw-text-center mt-2">
          <ExpandButton isExpanded={isExpanded} onClick={toggleExpanded} />
        </div>
      )}
    </div>
  );
};
